// Third party
import {
  AccountsListAllActiveDocument,
  AccountsListAllActiveQuery,
  AccountsListAllActiveQueryVariables,
} from '@gql';

// Utils
import { createApolloClient } from '../apollo-node-client';

type Options = {
  variables?: AccountsListAllActiveQueryVariables;
};

export const imperativeNodeActiveAccountsQuery = async (options: Options) => {
  const apolloClient = createApolloClient();

  const result = await apolloClient.query<AccountsListAllActiveQuery>({
    query: AccountsListAllActiveDocument,
    ...options,
  });

  return result.data.accountsListAllActive;
};

export type ActiveAccountPartial =
  AccountsListAllActiveQuery['accountsListAllActive']['entries'][0];
